import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import OrderStreamBoxedOrder from './live_order_stream_boxed_order';
import {observer, inject} from 'mobx-react';

const liveOrderQueue ={
    "color": "rgb(16, 43, 63)",
    "marginLeft": ".12vmin",
    "marginRight": ".12vmin"
};

@inject('RootStore')
@observer
export default class OrderStreamQueueColumn extends Component {

    render() {
        //this is how we decide on the size of the columns
        let columnWidth = `${86.5/this.props.RootStore.orderStore.columnCount}%`;
        let rows = [];
        for(let i=0; i < this.props.RootStore.orderStore.rowCount; i++) {
            rows.push(<OrderStreamBoxedOrder rowIndex={i} colIndex={this.props.colIndex} key={i}/>);
        }
        return (
            <Flexbox width={columnWidth} height="100%" flexDirection="column" style={liveOrderQueue}>
                {rows}
            </Flexbox>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/order_stream_widget/live_order_stream_queue_column.jsx